export default "__VITE_ASSET__CEuX93x1__"